var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#20434f",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    enableBackground: "new 0 0 48 48",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.729,22.94c1.401-1.562,2.263-3.618,2.263-5.875c0-4.86-3.955-8.815-8.815-8.815s-8.814,3.955-8.814,8.815 s3.954,8.815,8.814,8.815c1.713,0,3.309-0.499,4.664-1.35c4.793,1.807,8.094,6.193,8.513,11.266H10 c0.285-3.415,1.887-6.599,4.494-8.87c0.459-0.4,0.507-1.096,0.106-1.555c-0.398-0.459-1.095-0.508-1.554-0.107 C9.679,28.197,7.75,32.437,7.75,36.898C7.75,37.507,8.243,38,8.852,38H37.5c0.609,0,1.102-0.493,1.102-1.102 C38.602,30.854,35.099,25.455,29.729,22.94z M16.565,17.065c0-3.646,2.965-6.611,6.611-6.611s6.611,2.965,6.611,6.611 s-2.966,6.611-6.611,6.611S16.565,20.711,16.565,17.065z "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyAccount);
export default __webpack_public_path__ + "static/media/my-account.fac3ad1282c847206edcd9da0821a052.svg";
export { ForwardRef as ReactComponent };